<template>
  <div class="table-responsive">
    <base-crud
      crudName="Tipos de Veículos"
      newText="Novo Tipo de Veículo"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="false"
      :dataForm="dataForm"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "vehicleTypesTable",
      pages: [],
      url: "",
      columns: ["id", "description", "km_start", "km_end", "actions"],
      tableData: ["id", "description", "km_start", "km_end"],
      options: {
        sortable: ["id", "description", "km_start", "km_end"],
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "description", "km_start", "km_end"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          description: "Descrição",
          km_start: "KM Inicial",
          km_end: "KM Final",
          actions: "Ações",
        },
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "vehicleTypes/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        description: "description",
        km_start: "km_start",
        km_end: "km_end",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/VehicleTypes/Crud.vue